import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Bars3Icon } from '@heroicons/react/24/outline';
import AdminSidebar from './AdminSidebar';
import Logo from '../common/Logo';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);
      if (desktop) {
        setSidebarOpen(true);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div className="h-screen flex overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <AdminSidebar 
        isOpen={sidebarOpen} 
        setIsOpen={setSidebarOpen}
        isDesktop={isDesktop}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile Header */}
        {!isDesktop && (
          <div className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-gray-200 px-3 py-3 flex items-center justify-between">
            {/* Menu button (right in RTL) */}
            <button
              onClick={() => setSidebarOpen(true)}
              aria-label="فتح القائمة"
              className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-800 transition-colors"
            >
              <Bars3Icon className="h-6 w-6" />
            </button>

            {/* Centered brand logo */}
            <div className="flex-1 flex justify-center">
              <Logo className="h-7 w-auto" />
            </div>

            {/* Spacer to keep logo centered */}
            <div className="w-8" />
          </div>
        )}

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-6 bg-gradient-to-br from-gray-50 via-primary-50/30 to-secondary-50/20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="max-w-full"
          >
            {children}
          </motion.div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
